import { OutputParametricSelector, createSelector } from "@reduxjs/toolkit";
import { SliceStatus } from "interfaces";

import { RootState, StateSlices } from "./rootReducer";

function getSliceRequesting(state: RootState, filter: StateSlices): SliceStatus {
  return state[filter].status;
}

function getSliceError(state: RootState, filter: StateSlices): string {
  return state[filter].error;
}

export const makeSliceRequesting = (): OutputParametricSelector<
  RootState,
  StateSlices,
  SliceStatus,
  (res: SliceStatus) => SliceStatus
> => createSelector([getSliceRequesting], isLoading => isLoading);

export const makeSliceError = (): OutputParametricSelector<RootState, StateSlices, string, (res: string) => string> =>
  createSelector([getSliceError], error => error);
